var Dispatcher = require("./Dispatcher.js");

module.exports = new Dispatcher();